import { Component } from '@angular/core';
import { HeaderComponent } from "../header/header.component";
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { WishListComponent } from "./WishList/wish-list/wish-list.component";
import { UpcomingComponent } from "./Upcoming/upcoming/upcoming.component";
import { PreviousComponent } from "./previous/previous.component";
import { ManageComponent } from "./manage/manage.component";
import { AuthService } from '../../services/Auth/auth.service';
import { DeleteOverlayComponent } from "./delete-overlay/delete-overlay.component";

@Component({
    selector: 'app-profile-page',
    imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    WishListComponent,
    UpcomingComponent,
    PreviousComponent,
    ManageComponent,
    DeleteOverlayComponent
],
    templateUrl: './profile-page.component.html',
    styleUrl: './profile-page.component.scss'
})
export class ProfilePageComponent {
    public section: string

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public authService: AuthService
    ) {
        this.section = "wishlist"
    }

    ngOnInit() {
        this.activatedRoute.paramMap.subscribe(params => {
            const section = params.get('id'); // 'id' is the parameter name from your route
            if(section) {
                this.section = section
            }
        });
    }

    logout() {
        this.authService.logout()
    }
}
